import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import * as customerActions from "../../../actions/customerActions";
import * as codeActions from "../../../actions/codeActions";
import * as modalActions from "../../../actions/modalActions";

import ContactList from "./ContactList";
import ContactForm from "./ContactForm";

import Modal from "../../common/Modal";
import ConfirmModal from "../../common/ConfirmModal";
import HeaderWrapper from "../../common/HeaderWrapper";

class CustomerContactsPage extends Component {
  constructor(props) {
    super(props);
    this.state = { search: "", contact: {}, adding: false };
  }

  onClickAdd = () => {
    this.setState({ contact: {}, adding: true });
    this.props.actions.showModalSuccess("customerContactModal");
  };

  onClickView = (contactId) => {
    const { customer } = this.props;
    const contact = customer.contacts.find((x) => x._id === contactId);
    this.setState({ contact, adding: false });
    this.props.actions.showModalSuccess("customerContactModal");
  };

  onClickDelete = (contactId) => {
    this.props.actions.requestContactId(contactId);
  };

  handleAdd = (contact) => {
    const { customer } = this.props;
    this.props.actions.createContact(customer._id, contact);
  };

  handleSave = (contact) => {
    const { customer } = this.props;
    this.props.actions.updateContact(customer._id, contact);
  };

  handleDelete = () => {
    const { customer, customerContactToDelete } = this.props;
    this.props.actions.deleteContact(customer._id, customerContactToDelete);
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { customer, codes, savingContact, isMobile } = this.props;
    const { contact, search, adding } = this.state;

    const contactForm = (
      <ContactForm
        customer={customer}
        contact={contact}
        codes={codes}
        adding={adding}
        saving={savingContact}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.props.actions.hideModal}
        savingCustomer={this.props.savingCustomer}
      />
    );

    return (
      <div id="contacts">
        <HeaderWrapper
          breadcrumbs={[{ label: "Contacts" }]}
          onClickEdit={this.handleEdit}
          onClickAdd={this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <ContactList
            minimal
            customer={customer}
            isMobile={isMobile}
            search={search}
            onClickView={this.onClickView}
            onClickDelete={this.onClickDelete}
          />
          <Modal
            id="customerContactModal"
            title={
              adding
                ? "Add Contact"
                : `${contact.first_name} ${contact.last_name}`
            }
            body={contactForm}
            close={this.props.actions.hideModal}
          />
          <ConfirmModal
            id="contactDeleteModal"
            title="Delete Contact"
            body="Are you sure you want to delete this contact?"
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </div>
    );
  }
}

CustomerContactsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  customerContactToDelete: PropTypes.string,
  savingCustomer: PropTypes.bool,
  codes: PropTypes.array,
  customer: PropTypes.object,
  savingContact: PropTypes.bool,
  isMobile: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    customer: state.reducers.customer,
    customerContactToDelete: state.reducers.customerContactToDelete,
    savingCustomer: state.reducers.savingCustomer,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...customerActions, ...modalActions, ...codeActions },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(CustomerContactsPage)
);
